import React, { useState, useCallback, useEffect } from "react";
import cn from "classnames";
import styles from "./TripAndCharge.module.scss";
import TripPopup from "./TripPopup";
import Gantt from "../echarts/Gantt1";
import Calendar from "shared/Calendar";
import {
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
} from "../../services/axiosBaseClient";
import {
  dateFormateTrip,
  dateFormateTripTime,
  adddateFormateTrip,
  ViewFormateOnly,
} from "../timeDiffCalc";
// import DatePicker from 'react-date-picker';
// import "react-date-picker/dist/DatePicker.css"
// var section = $('div.table__cell');

// function toggleAccordion() {
// section.removeClass('active');
// $(this).addClass('active');
// }
import moment from "moment";
import { typeOf } from "react-is";
//section.on('click', toggleAccordion);

// var date ="05/05/2022"
export default function TripAndCharge(props) {
  var chargerId = [props?.charId];
  var Arraycount = props.rowData.length;
  let EuDateFormate = process.env.REACT_APP_UNITS_SYSTEM;
  let currentday = new Date().getDay();
  let Urls = window.location.href.toString().split(window.location.host)[1];

  let checkBoxCheked = localStorage.getItem("TripSechedule");
  // var addbuttonClick = 'edit';
  var [selectedDay, setSelectedDay] = useState(currentday - 1);
  // const [dateValue, onChange] = useState(new Date());
  const [chargertripstate, setChargerTripState] = useState(checkBoxCheked);
  const [selectedDate, setSelectedSate] = useState();
  const [trippopData, setTripPopup] = useState(false);
  const [secondPopup, setSecondPopup] = useState("false");
  const [addtripcharge, setAddTripCharge] = useState("edit");
  const [nextWeek, setNextWeek] = useState(0);
  const [PreviousWeek, setPreviousWeek] = useState(0);
  const [todaydate, setTodaydate] = useState("");
  const [sheduleddata, setsheduleddata] = useState();
  var [chargertableRow, setChargertableRow] = useState();
  var [chargerGraph, setChargerGraph] = useState();
  var [chargerList, setChargerList] = useState();
  var [hideaddbutton, setHideaddbutton] = useState(false);
  var [showError, setShowError] = useState(false);
  var [todayClick, setTodayClick] = useState(false);
  // var [graphWidth, setGraphWidth] = useState(0)
  var recurringId;

  var chargerGraphdata = [];
  const selectDate = useCallback((data, day, selectedStr) => {
    "";
    setTodaydate("");
    if (selectedStr === "NextPreviousBlank") {
      setPreviousWeek(0);
      setNextWeek(0);
    }
    if (data !== "") {
      setTodayClick(false);
      if (day != undefined) {
        setSelectedDay(day - 1);
      } else {
      }
      setSelectedSate(data);
    }
    // setSelectedSate(data)
    checkDate(data);
  }, []);
  const today = () => {
    setPreviousWeek(0);
    setNextWeek(0);
    let startDate = new Date();
    localStorage.setItem("selecteddate", startDate);
    let dd = String(startDate.getDate()).padStart(2, "0");
    let mm = String(startDate.getMonth() + 1).padStart(2, "0"); //January is 0!
    let yyyy = startDate.getFullYear();
    var date;
    if (EuDateFormate === "metric") {
      date = dd + "/" + mm + "/" + yyyy;
    } else {
      date = mm + "/" + dd + "/" + yyyy;
    }

    if (currentday === 0) {
      setSelectedDay(6);
    } else {
      setSelectedDay(currentday - 1);
    }

    setSelectedSate(date);
    setTodaydate(date);
    checkDate(date);
    setTodayClick(true);
    chargerListdata();
  };

  var date = selectedDate;
  function handleChange(evt) {
    setChargerTripState(evt.target.value);
  }
  const TripPData = useCallback((data) => {
    // console.log(data)
    if (Urls !== "/TripAndChargeSchedule") {
      if (data.dataVa[1] > 10000) {
        setTripPopup(data.dataVa);
        setAddTripCharge("edit");
        setSecondPopup(data.stateP);
      } else {
        setSecondPopup(false);
      }
    }
  }, []);

  const closePopup = useCallback((data) => {
    setSecondPopup(data);
  }, []);

  function addHandleChange(evt) {
    setAddTripCharge("addData");
    setSecondPopup(evt);
    // addbuttonClick="addData"
  }

  const nextWeak = (e) => {
    setPreviousWeek(0);
    setNextWeek(nextWeek + 1);
  };
  const previousWeak = () => {
    setNextWeek(0);
    setPreviousWeek(PreviousWeek + 1);
  };
  const deleteCallBack = (strType, strRecurring) => {
    delSchedule(strType, strRecurring);
  };
  const callBackscheduleData = useCallback((data, strType, strRecurring) => {
    setsheduleddata(data);
    setSecondPopup(false);
    setAddTripCharge(strType);
    saveScheduled(data, strType, strRecurring);
  }, []);
  function addHours(numOfHours) {
    let fromDate1;
    if (todayClick === true) {
      fromDate1 = new Date();
    } else {
      fromDate1 = localStorage.getItem("selecteddate");
    }

    date = new Date(fromDate1);
    let frmdate = date.setHours(0, 0, 0, 0);
    let abc = new Date(frmdate);
    abc?.setTime(abc?.getTime() + numOfHours * 60 * 60 * 1000);
    return abc;
  }
  const checkDate = (data) => {
    // console.log(typeof (data), data);
    let checkCurrentdate = new Date();
    let dd = String(checkCurrentdate.getDate()).padStart(2, "0");
    let mm = String(checkCurrentdate.getMonth() + 1).padStart(2, "0"); //January is 0!
    let yyyy = checkCurrentdate.getFullYear();

    var date;
    var dateCurent = "";
    if (EuDateFormate === "metric") {
      date = mm + "/" + dd + "/" + yyyy;
      if (data !== "") {
        let str = data?.split("/");
        let strdd = str[0];
        let strmm = str[1];
        let strYyyy = str[2];
        dateCurent = strmm + "/" + strdd + "/" + strYyyy;
      }
    } else {
      date = mm + "/" + dd + "/" + yyyy;
      if (data !== "") {
        let str = data?.split("/");
        let strdd = str[1];
        let strmm = str[0];
        let strYyyy = str[2];
        dateCurent = strmm + "/" + strdd + "/" + strYyyy;
      }
    }

    var dateConv = new Date(date);
    let seletedDate = new Date(dateCurent);
    if (seletedDate < dateConv) {
      if (data !== "") {
        setHideaddbutton(true);
      } else {
        setHideaddbutton(false);
      }
    } else {
      setHideaddbutton(false);
    }
  };

  function isValidDate(dateObject) {
    return new Date(dateObject).toString() !== "Invalid Date";
  }

  // useEffect(() => {
  //   checkDate();
  // },[checkDate])
  useEffect(() => {
    if (chargerId?.length > 0) {
      if (selectedDate !== undefined) {
        chargerListdata();
      }
    }
  }, [selectedDate]);

  const splId = props?.charId?.split(",");
  const len = splId.length;

  const saveScheduled = async (postData, strType, strRecurring) => {
    if (strType === "addData" || strType === "edit") {
      if (chargertripstate === "Charging Schedule") {
        if (strRecurring === "Recurring") {
          const splId = props?.charId?.split(",");
          const len = splId?.length;
          setShowError(false);

          for (let i = 0; i < props?.tripChargeSchedule?.length; i++) {
            let addSheduleJson = JSON.parse(postData);
            const newASetPoint = addSheduleJson?.setpoints?.map((item) => {
              if (item?.power > 0) {
                return {
                  ...item,
                  power: props?.tripChargeSchedule[i]?.trpCharge,
                };
              }
              return item;
            });
            // let toDate = dateFormateTrip(addSheduleJson?.effectivePeriod.to, props?.tripChargeSchedule[i]?.timezone)
            // let fromDate = dateFormateTrip(addSheduleJson?.effectivePeriod.from, props?.tripChargeSchedule[i]?.timezone)

            // let ToTime = dateFormateTripTime(addSheduleJson?.effectivePeriod.to, props?.tripChargeSchedule[i]?.timezone)
            // let fromTime = dateFormateTripTime(addSheduleJson?.effectivePeriod.from, props?.tripChargeSchedule[i]?.timezone)
            let toDate = adddateFormateTrip(
              addSheduleJson?.effectivePeriod.to,
              props?.tripChargeSchedule[i]?.timezone
            );
            let fromDate = adddateFormateTrip(
              addSheduleJson?.effectivePeriod.from,
              props?.tripChargeSchedule[i]?.timezone
            );

            // 2022-08-24T01:00:27.000Z
            let toDateTime = toDate + ":00.000Z";
            let fromDateTime = fromDate + ":00.000Z";
            let effectiveTime = {
              to: toDateTime,
              from: fromDateTime,
            };
            let sheduledata = {
              setpoints: newASetPoint,
              timezone: props?.tripChargeSchedule[i]?.timezone,
              effectivePeriod: effectiveTime,
            };

            let objTrip = JSON.stringify(sheduledata);

            try {
              await postRequest(
                `evses/` +
                  props?.tripChargeSchedule[i].id +
                  `/weekly-power-setpoints-schedules`,
                objTrip
              ).then((resData) => {
                if (resData) {
                  chargerListdata();
                }
              });
            } catch (error) {
              setShowError(true);
              console.log("Can not add duplicate schedule!!!");
            }
          }

          // })
        }
      } else {
        //trip Schedule add block
        const splId = props?.charId?.split(",");
        const len = splId.length;
        if (strRecurring === "Recurring") {
          for (let i = 0; i < props?.tripChargeSchedule?.length; i++) {
            let addSheduleJson = JSON.parse(postData);
            // let toDate = dateFormateTrip(addSheduleJson?.recurrence?.to, props?.tripChargeSchedule[i]?.timezone)
            // let fromDate = dateFormateTrip(addSheduleJson?.recurrence?.from, props?.tripChargeSchedule[i]?.timezone)

            // let ToTime = dateFormateTripTime(addSheduleJson?.recurrence.to, props?.tripChargeSchedule[i]?.timezone)
            // let fromTime = dateFormateTripTime(addSheduleJson?.recurrence.from, props?.tripChargeSchedule[i]?.timezone)
            let toDate = adddateFormateTrip(
              addSheduleJson?.recurrence?.to,
              props?.tripChargeSchedule[i]?.timezone
            );
            let fromDate = adddateFormateTrip(
              addSheduleJson?.recurrence?.from,
              props?.tripChargeSchedule[i]?.timezone
            );
            // 2022-08-24T01:00:27.000Z
            let toDateTime = toDate + ":00.000Z";
            let fromDateTime = fromDate + ":00.000Z";
            let effectiveTime = {
              to: toDateTime,
              from: fromDateTime,
            };
            // let timePeriod = {
            //   from: fromTime,
            //   to: ToTime
            // }
            let sheduledata = {
              name: addSheduleJson?.name,
              period: addSheduleJson?.period,
              soc: addSheduleJson?.soc,
              daysOfWeek: addSheduleJson?.daysOfWeek,
              recurrence: effectiveTime,
            };

            let objTrip = JSON.stringify(sheduledata);

            try {
              await postRequest(
                `vehicles/` +
                  props?.tripChargeSchedule[i].id +
                  `/recurring-soc-requirements`,
                objTrip
              ).then((resData) => {
                // await postRequest(`evses/` + props?.tripChargeSchedule[i].id + `/weekly-power-setpoints-schedules`, objTrip).then((resData) => {

                if (resData) {
                  chargerListdata();
                }
              });
            } catch (error) {
              setShowError(true);
              console.log("Can not add duplicate schedule!!!");
            }
          }
          // for (let i = 0; i < len; i++) {

          //   try {
          //     await postRequest(`vehicles/` + splId[i] + `/recurring-soc-requirements`, postData).then((resData) => {
          //       if (resData) {
          //         chargerListdata();
          //       }

          //     });
          //   } catch (error) {
          //     console.log('Can not add duplicate schedule!!!')
          //   }
          // }
        } else {
          for (let i = 0; i < props?.tripChargeSchedule?.length; i++) {
            let addSheduleJson = JSON.parse(postData);
            let toDate = adddateFormateTrip(
              addSheduleJson?.period.to,
              props?.tripChargeSchedule[i]?.timezone
            );
            let fromDate = adddateFormateTrip(
              addSheduleJson?.period.from,
              props?.tripChargeSchedule[i]?.timezone
            );
            //  debugger
            // let toDate = dateFormateTrip(addSheduleJson?.period.to, props?.tripChargeSchedule[i]?.timezone)
            // let fromDate = dateFormateTrip(addSheduleJson?.period.from, props?.tripChargeSchedule[i]?.timezone)

            // let ToTime = dateFormateTripTime(addSheduleJson?.period.to, props?.tripChargeSchedule[i]?.timezone)
            // let fromTime = dateFormateTripTime(addSheduleJson?.period.from, props?.tripChargeSchedule[i]?.timezone)
            // 2022-08-24T01:00:27.000Z
            //  debugger
            let toDateTime = toDate + ":00.000Z";
            let fromDateTime = fromDate + ":00.000Z";
            let priodObj = {
              from: fromDateTime,
              to: toDateTime,
            };
            let tripObj = {
              name: addSheduleJson?.name,
              soc: addSheduleJson?.soc,
              period: priodObj,
            };
            // console.log('timeZone', props?.tripChargeSchedule[i]?.timezone, props?.tripChargeSchedule[i]?.id)
            try {
              await postRequest(
                `vehicles/` +
                  props?.tripChargeSchedule[i]?.id +
                  `/one-time-soc-requirements`,
                tripObj
              ).then((resData) => {
                if (resData) {
                  chargerListdata();
                }
              });
            } catch (error) {
              console.log("Can not add duplicate schedule!!!");
            }
          }
        }
      }
    } else {
      //edit charger block
      // try {
      //   adddlert("Welcome guest!");
      // }
      // catch(err) {
      //   document.getElementById("demo").innerHTML = err.message;
      // }
      if (strRecurring === "Recurring") {
        var id = localStorage.getItem("recurringID");
        await putRequest(
          `weekly-power-setpoints-schedules/` + id,
          postData
        ).then((resData) => {
          if (resData) {
            chargerListdata();
          }
        });
      }
    }
  };

  const dayCount = (day) => {
    // for(let i=0;i<day?.length;i++){
    if (day === "MONDAY") {
      return 0;
    } else if (day === "TUESDAY") {
      return 1;
    } else if (day === "WEDNESDAY") {
      return 2;
    } else if (day === "THURSDAY") {
      return 3;
    } else if (day === "FRIDAY") {
      return 4;
    } else if (day === "SATURDAY") {
      return 5;
    } else if (day === "SUNDAY") {
      return 6;
    }
    // }
  };
  var charListVal = [];

  const chargerListdata = async () => {
    let fromDate1;
    if (todayClick === true) {
      fromDate1 = new Date();
    } else {
      fromDate1 = localStorage.getItem("selecteddate");
    }
    let chargerTableData = [];
    const fromDate = new Date(fromDate1);
    let frmdate = fromDate.setHours(0, 0, 0, 0);
    let dateTime = moment(frmdate).format("YYYY-MM-DDT00:00");
    const fromdateTime1 = dateTime + ":00.000Z";
    let dateTimeTo = moment(frmdate).format("YYYY-MM-DDT23:59");
    const TodateTime1 = dateTimeTo + ":00.000Z";
    let dateToISO = new Date(frmdate);
    //  var isoDateTime = new Date(dateToISO.getTime() - (dateToISO.getTimezoneOffset() * 60000)).toISOString();
    const fromdateTime =
      isValidDate(dateToISO) === false ? "" : dateToISO?.toISOString();
    const toDate = addHours(24);
    const todateTime = isValidDate(toDate) ? toDate?.toISOString() : "";
    if (chargertripstate === "Trip Schedule") {
      let newChargerdata = [];
      let newrecVehData = [];
      for (let i = 0; i < props?.tripChargeSchedule?.length; i++) {
        let toDate = adddateFormateTrip(
          dateTimeTo,
          props?.tripChargeSchedule[i]?.timezone
        );
        let fromDate = adddateFormateTrip(
          dateTime,
          props?.tripChargeSchedule[i]?.timezone
        );
        const fromdateTime2 = fromDate + ":00.000Z";
        const TodateTime2 = toDate + ":00.000Z";
        let chargerdata1 = await getRequest(
          `vehicles/one-time-soc-requirements?from=` +
            fromdateTime2 +
            `&to=` +
            TodateTime2 +
            `&vehicleIds=` +
            props?.tripChargeSchedule[i]?.id
        ).then((resData) => {
          return resData?.data;
        });

        let recVehData1 = await getRequest(
          `vehicles/recurring-soc-requirements?from=` +
            fromdateTime2 +
            `&to=` +
            TodateTime2 +
            `&vehicleIds=` +
            props?.tripChargeSchedule[i]?.id
        ).then((resData) => {
          return resData?.data;
        });

        newChargerdata?.push(chargerdata1?.vehicleOneTimeSocRequirement[0]);
        let chargerdata = {
          vehicleOneTimeSocRequirement: newChargerdata,
        };

        newrecVehData?.push(recVehData1?.vehiclesRecurringSocRequirement[0]);
        let recVehData = {
          vehiclesRecurringSocRequirement: newrecVehData,
        };

        if (
          chargerdata?.vehicleOneTimeSocRequirement?.length > 0 &&
          recVehData?.vehiclesRecurringSocRequirement?.length > 0
        ) {
          chargerTableData = [];
          props?.rowData.map((item) => {
            let objIndex =
              recVehData?.vehiclesRecurringSocRequirement?.findIndex(
                (obj) => obj?.vehicleId === item?.id
              );
            let objIndex1 =
              chargerdata?.vehicleOneTimeSocRequirement?.findIndex(
                (obj) => obj?.vehicleId === item?.id
              );

            let timezone = props?.tripChargeSchedule?.find((val) => {
              if (val.id === item?.id) {
                return props?.tripChargeSchedule;
              }
            });
            let fleettimeZone =
              timezone?.timezone !== undefined ? timezone?.timezone : "";
            // console.log(fleettimeZone)
            chargerTableData?.push({
              id: item?.vehicle?.vehID,
              chargerName: item?.vehicle?.name,
              chargerPort: item?.vehicle?.model,
              vehicleId:
                recVehData?.vehiclesRecurringSocRequirement[objIndex]
                  ?.vehicleId,
              name: recVehData?.vehiclesRecurringSocRequirement[objIndex]
                ?.recurringSocRequirements,
              setpoints:
                recVehData?.vehiclesRecurringSocRequirement[objIndex]
                  ?.recurringSocRequirements !== undefined
                  ? recVehData?.vehiclesRecurringSocRequirement[objIndex]
                      ?.recurringSocRequirements
                  : [],
              weekDay:
                recVehData?.vehiclesRecurringSocRequirement[objIndex]
                  ?.recurringSocRequirements[objIndex]?.daysOfWeek,
              period:
                chargerdata?.vehicleOneTimeSocRequirement[objIndex1]
                  ?.socRequirements !== undefined
                  ? chargerdata?.vehicleOneTimeSocRequirement[objIndex1]
                      ?.socRequirements
                  : "",
              timeZone: fleettimeZone,
            });
          });
          props?.rowData.map((item) => {
            let objIndex1 =
              chargerdata?.vehicleOneTimeSocRequirement?.findIndex(
                (obj) => obj?.vehicleId === item?.id
              );
            let objIndex2 = chargerTableData?.findIndex(
              (obj) => obj?.id === item?.id
            );
            if (objIndex2 >= 0) {
              for (
                let i = 0;
                i < chargerTableData[objIndex2]?.period?.length;
                i++
              ) {
                chargerTableData[objIndex2]?.setpoints.push(
                  chargerdata?.vehicleOneTimeSocRequirement[objIndex1]
                    ?.socRequirements !== undefined
                    ? chargerdata?.vehicleOneTimeSocRequirement[objIndex1]
                        ?.socRequirements[i]
                    : ""
                );
              }
            }
          });
        } else if (recVehData?.vehiclesRecurringSocRequirement?.length > 0) {
          chargerTableData = [];
          props?.rowData?.map((item) => {
            let objIndex =
              recVehData?.vehiclesRecurringSocRequirement?.findIndex(
                (obj) => obj?.vehicleId === item?.id
              );
            let timezone = props?.tripChargeSchedule?.find((val) => {
              if (val.id === item?.id) {
                return props?.tripChargeSchedule;
              }
            });
            let fleettimeZone =
              timezone?.timezone !== undefined ? timezone?.timezone : "";
            // console.log(fleettimeZone)
            chargerTableData?.push({
              id: item?.id,
              chargerName: item?.vehicle?.name,
              chargerPort: item?.vehicle?.model,
              name: recVehData?.vehiclesRecurringSocRequirement[objIndex]
                ?.recurringSocRequirements,
              setpoints:
                recVehData?.vehiclesRecurringSocRequirement[objIndex]
                  ?.recurringSocRequirements !== undefined
                  ? recVehData?.vehiclesRecurringSocRequirement[objIndex]
                      ?.recurringSocRequirements
                  : "",
              weekDay:
                recVehData?.vehiclesRecurringSocRequirement[objIndex]
                  ?.recurringSocRequirements[objIndex]?.daysOfWeek,
              timeZone: fleettimeZone,
            });
          });
        } else {
          chargerTableData = [];
          props?.rowData?.map((item) => {
            let objIndex = chargerdata?.vehicleOneTimeSocRequirement?.findIndex(
              (obj) => obj?.vehicleId === item?.id
            );

            let timezone = props?.tripChargeSchedule?.find((val) => {
              if (val.id === item?.id) {
                return props?.tripChargeSchedule;
              }
            });
            let fleettimeZone =
              timezone?.timezone !== undefined ? timezone?.timezone : "";
            // console.log(fleettimeZone)
            chargerTableData?.push({
              id: item?.id,
              chargerName: item?.vehicle?.name,
              chargerPort: item?.vehicle?.model,
              setpoints:
                chargerdata?.vehicleOneTimeSocRequirement[objIndex]
                  ?.socRequirements !== undefined
                  ? chargerdata?.vehicleOneTimeSocRequirement[objIndex]
                      ?.socRequirements
                  : "",
              timeZone: fleettimeZone,
            });
          });
        }
      }
    } else {
      let newChargerdata = [];
      for (let i = 0; i < props?.tripChargeSchedule?.length; i++) {
        // debugger
        let toDate = adddateFormateTrip(
          dateTimeTo,
          props?.tripChargeSchedule[i]?.timezone
        );
        let fromDate = adddateFormateTrip(
          dateTime,
          props?.tripChargeSchedule[i]?.timezone
        );
        const fromdateTime2 = fromDate + ":00.000Z";
        const TodateTime2 = toDate + ":00.000Z";
        let chargerdata1 = await getRequest(
          `evses/weekly-power-setpoints-schedules?evseIds=` +
            props?.tripChargeSchedule[i]?.id +
            `&from=` +
            fromdateTime2 +
            `&to=` +
            TodateTime2
        ).then((resData) => {
          return resData?.data;
        });

        newChargerdata?.push(chargerdata1?.schedules[0]);
        let chargerdata = {
          schedules: newChargerdata,
        };
        // console.log('chart',chargerdata)
        if (chargerdata?.schedules) {
          chargerTableData = [];
          props?.rowData?.map((item) => {
            let objIndex = chargerdata?.schedules?.findIndex(
              (obj) => obj?.evseId === item?.id
            );
            let timezone = props?.tripChargeSchedule?.find((val) => {
              if (val.id === item?.id) {
                return props?.tripChargeSchedule;
              }
            });
            let chargerTimeZone =
              timezone?.timezone !== undefined ? timezone?.timezone : "";

            chargerTableData?.push({
              id: item?.id,
              chargerName: item?.charger?.name,
              period: chargerdata?.schedules[objIndex]?.effectivePeriod,
              chargerPort: item?.charger?.port,
              chargerId: chargerdata?.schedules[objIndex]?.id,
              setpoints:
                chargerdata?.schedules[objIndex]?.setpoints !== undefined
                  ? chargerdata?.schedules[objIndex]?.setpoints
                  : "",
              timeZone: chargerTimeZone,
            });
          });
        }
      }
    }

    charListVal = [];
    chargerGraphdata = [[102000, "", ""]];

    if (chargertripstate === "Trip Schedule") {
      let getdate = new Date(fromDate1);
      let sdd = String(getdate.getDate()).padStart(2, "0");
      let smm = String(getdate.getMonth() + 1).padStart(2, "0");
      let syyyy = getdate.getFullYear();
      let currentdate = syyyy + "-" + smm + "-" + sdd;

      charListVal = [[0, fromdateTime, todateTime, todateTime]];
      for (let i = 0; i <= chargerTableData?.length; i++) {
        chargerGraphdata?.push([
          chargerTableData[i]?.id,
          chargerTableData[i]?.chargerName,
          chargerTableData[i]?.chargerPort,
          chargerTableData[i]?.timeZone,
        ]);
        for (let j = 0; j < chargerTableData[i]?.setpoints?.length; j++) {
          if (chargerTableData[i]?.setpoints[0]?.period) {
            var fromdate1;
            var todate;
            var recFromdate;
            for (
              let k = 0;
              k < chargerTableData[i]?.setpoints[j]?.daysOfWeek?.length;
              k++
            ) {
              let weekdays = chargerTableData[i]?.setpoints[j]?.daysOfWeek[k];
              let daysCount = dayCount(weekdays);
              if (
                chargerTableData[i]?.setpoints[j].hasOwnProperty(
                  "recurrence"
                ) ||
                chargerTableData[i]?.setpoints[j]?.name === "Recurring"
              ) {
                recFromdate = chargerTableData[i]?.setpoints[0]?.recurrence?.to;
                if (daysCount === selectedDay) {
                  // let ToTime = dateFormateTripTime(currentdate + "T" +chargerTableData[i]?.setpoints[j]?.period?.to, chargerTableData[i]?.timeZone)
                  // let fromTime = dateFormateTripTime(currentdate + "T" +chargerTableData[i]?.setpoints[j]?.period?.from, chargerTableData[i]?.timeZone)

                  fromdate1 =
                    currentdate +
                    "T" +
                    chargerTableData[i]?.setpoints[j]?.period?.from;
                  todate =
                    currentdate +
                    "T" +
                    chargerTableData[i]?.setpoints[j]?.period?.to;
                  // fromdate1 = currentdate + "T" + chargerTableData[i]?.setpoints[j]?.period?.from;
                  // todate = currentdate + 'T' + chargerTableData[i]?.setpoints[j]?.period?.to
                }
                // else {
                //   fromdate1 = "";
                //   todate = ""
                // }
              } else {
                let stime = chargerTableData[i]?.setpoints[j]?.period?.from;
                if (stime !== undefined) {
                  let stdate = stime.substring(0, stime.length - 4);
                  let toDate1 = dateFormateTrip(
                    stdate,
                    chargerTableData[i]?.timeZone
                  );
                  let ToTime = dateFormateTripTime(
                    stdate,
                    chargerTableData[i]?.timeZone
                  );
                  fromdate1 = toDate1 + "T" + ToTime + ":00";
                } else {
                  fromdate1 = stime;
                }
                let toTime = chargerTableData[i]?.setpoints[j]?.period?.to;
                if (toTime !== undefined) {
                  let ttime2 = toTime.substring(0, toTime.length - 4);
                  let fromDate = dateFormateTrip(
                    ttime2,
                    chargerTableData[i]?.timeZone
                  );
                  let fromTime = dateFormateTripTime(
                    ttime2,
                    chargerTableData[i]?.timeZone
                  );
                  todate = fromDate + "T" + fromTime + ":00";
                } else {
                  todate = toTime;
                }
              }
            }
            let twoDaysFromTime = "";
            let twoDaysToTime = "";
            let TripOneTime = "";
            if (chargerTableData[i]?.setpoints[j]?.name === "Trip Schedule") {
              TripOneTime = "TripOneTime";
              let getdate = new Date(fromDate1);
              let sdd = String(getdate.getDate()).padStart(2, "0");
              let smm = String(getdate.getMonth() + 1).padStart(2, "0");
              let syyyy = getdate.getFullYear();
              let currentdate = syyyy + "-" + smm + "-" + sdd;

              let stime = chargerTableData[i]?.setpoints[j]?.period?.from;
              let toTime = chargerTableData[i]?.setpoints[j]?.period?.to;

              if (stime !== undefined || toTime !== undefined) {
                let stdate = stime.substring(0, stime.length - 4);
                let ttime2 = toTime.substring(0, toTime.length - 4);
                let startDateCompaire = new Date(stdate);
                // let toDate1 = dateFormateTrip(stdate, chargerTableData[i]?.timeZone)
                let fromDate = dateFormateTrip(
                  ttime2,
                  chargerTableData[i]?.timeZone
                );
                var fromDateTime = new Date(fromDate);
                let seletedDateTime = new Date(currentdate);

                if (seletedDateTime < fromDateTime) {
                  let startdate = stime.substring(0, stime.length - 4);
                  let startDate = dateFormateTrip(
                    startdate,
                    chargerTableData[i]?.timeZone
                  );
                  let startTime = dateFormateTripTime(
                    startdate,
                    chargerTableData[i]?.timeZone
                  );
                  let fromdateUtc = startDate + "T" + startTime + ":00";
                  twoDaysToTime = fromdateUtc;
                  let ttime2 = toTime.substring(0, toTime.length - 4);
                  let fromDate = dateFormateTrip(
                    ttime2,
                    chargerTableData[i]?.timeZone
                  );
                  let fromTime = dateFormateTripTime(
                    ttime2,
                    chargerTableData[i]?.timeZone
                  );
                  let todateUtc = fromDate + "T" + fromTime + ":00";
                  twoDaysFromTime = todateUtc;
                  let fromdateCalulation = new Date(fromdateUtc);
                  // let toCalulation = new Date(todateUtc);

                  let getFromHours = fromdateCalulation.getHours();
                  let getFromMin = fromdateCalulation.getMinutes();
                  let getMin = getStringMinHours(getFromMin);
                  let getHour = getStringMinHours(getFromHours);

                  fromdate1 =
                    currentdate + "T" + getHour + ":" + getMin + ":00";
                  todate = currentdate + "T" + "23:59:00";
                } else {
                  let stime = chargerTableData[i]?.setpoints[j]?.period?.from;
                  let toTime = chargerTableData[i]?.setpoints[j]?.period?.to;
                  let fromTime = dateFormateTrip(
                    stime,
                    chargerTableData[i].timeZone
                  );
                  let ToTime = dateFormateTrip(
                    toTime,
                    chargerTableData[i].timeZone
                  );
                  let fromDate2 = new Date(fromTime);
                  let toDate2 = new Date(ToTime);

                  if (
                    fromDate2.getFullYear() === toDate2.getFullYear() &&
                    fromDate2.getDate() === toDate2.getDate() &&
                    fromDate2.getMonth() === toDate2.getMonth()
                  ) {
                    TripOneTime = "";
                    if (stime !== undefined) {
                      let stdate = stime.substring(0, stime.length - 4);
                      let toDate1 = dateFormateTrip(
                        stdate,
                        chargerTableData[i]?.timeZone
                      );
                      let ToTime = dateFormateTripTime(
                        stdate,
                        chargerTableData[i]?.timeZone
                      );
                      fromdate1 = toDate1 + "T" + ToTime + ":00";
                    } else {
                      fromdate1 = stime;
                    }
                    if (toTime !== undefined) {
                      let ttime2 = toTime.substring(0, toTime.length - 4);
                      let fromDate = dateFormateTrip(
                        ttime2,
                        chargerTableData[i]?.timeZone
                      );
                      let fromTime = dateFormateTripTime(
                        ttime2,
                        chargerTableData[i]?.timeZone
                      );
                      todate = fromDate + "T" + fromTime + ":00";
                    } else {
                      todate = toTime;
                    }
                  } else {
                    let startdate = stime.substring(0, stime.length - 4);
                    let startDate = dateFormateTrip(
                      startdate,
                      chargerTableData[i]?.timeZone
                    );
                    let startTime = dateFormateTripTime(
                      startdate,
                      chargerTableData[i]?.timeZone
                    );
                    let fromdateUtc = startDate + "T" + startTime + ":00";
                    twoDaysToTime = fromdateUtc;
                    let ttime2 = toTime.substring(0, toTime.length - 4);
                    let fromDate = dateFormateTrip(
                      ttime2,
                      chargerTableData[i]?.timeZone
                    );
                    let fromTime = dateFormateTripTime(
                      ttime2,
                      chargerTableData[i]?.timeZone
                    );
                    let todateUtc = fromDate + "T" + fromTime + ":00";
                    twoDaysFromTime = todateUtc;
                    let fromdateCalulation = new Date(todateUtc);
                    let getFromHours = fromdateCalulation.getHours();
                    let getFromMin = fromdateCalulation.getMinutes();
                    let getMin = getStringMinHours(getFromMin);
                    let getHour = getStringMinHours(getFromHours);

                    fromdate1 = currentdate + "T" + "00:00:00";
                    todate = currentdate + "T" + getHour + ":" + getMin + ":00";
                  }
                }
              }
            }

            charListVal?.push([
              i + 1,
              new Date(Date.parse(fromdate1)),
              new Date(Date.parse(todate)),
              chargerTableData[i]?.setpoints[j]?.soc,
              chargerTableData[i]?.setpoints[j]?.name,
              chargerTableData[i]?.setpoints[j],
              // new Date(Date.parse(recFromdate)),
              // new Date(moment(recFromdate, "YYYY-MM-DDTHH:mm:ss")),
              new Date(
                moment(
                  dateFormateTrip(recFromdate, chargerTableData[i]?.timeZone),
                  "YYYY-MM-DD"
                )
              ),
              new Date(Date.parse(twoDaysFromTime)),
              new Date(Date.parse(twoDaysToTime)),
              TripOneTime,
            ]);
            // charListVal?.push(
            //   [
            //     i + 1,
            //     new Date(Date.parse(fromdate1)),
            //     new Date(Date.parse(todate)),
            //     chargerTableData[i]?.setpoints[j]?.soc,
            //     chargerTableData[i]?.setpoints[j]?.name,
            //     chargerTableData[i]?.setpoints[j],
            //   ]
            // )
          }
        }
      }
    } else {
      let getdate = new Date(fromDate1);
      let sdd = String(getdate.getDate()).padStart(2, "0");
      let smm = String(getdate.getMonth() + 1).padStart(2, "0");
      let syyyy = getdate.getFullYear();
      let currentdate = syyyy + "-" + smm + "-" + sdd;
      charListVal = [[0, fromdateTime, todateTime, todateTime]];
      for (let i = 0; i <= chargerTableData?.length; i++) {
        chargerGraphdata?.push([
          chargerTableData[i]?.id,
          chargerTableData[i]?.chargerName,
          chargerTableData[i]?.chargerPort,
        ]);

        var fromdate;
        var todate;
        var recFromdate;
        recFromdate = chargerTableData[i]?.period?.to;
        let cherID = chargerTableData[i]?.chargerId;
        for (let j = 0; j < chargerTableData[i]?.setpoints?.length; j++) {
          let selectDay = chargerdayMap(chargerTableData[i]?.setpoints[j]);
          if (chargerTableData[i]?.setpoints[j]?.power > 0) {
            if (selectDay === selectedDay) {
              // let ToTime = dateFormateTripTime(chargerTableData[i]?.setpoints[j]?.timespan?.to, chargerTableData[i]?.timeZone)
              // let fromTime = dateFormateTripTime(chargerTableData[i]?.setpoints[j]?.timespan?.from, chargerTableData[i]?.timeZone)
              // fromdate = currentdate + "T" + fromTime;
              // todate = currentdate + 'T' + ToTime
              // fromdate = currentdate + "T" + chargerTableData[i]?.setpoints[j]?.timespan?.from;
              // todate = currentdate + 'T' + chargerTableData[i]?.setpoints[j]?.timespan?.to;
              fromdate1 =
                currentdate +
                "T" +
                chargerTableData[i]?.setpoints[j]?.period?.from;
              todate =
                currentdate +
                "T" +
                chargerTableData[i]?.setpoints[j]?.period?.to;
            } else {
              fromdate = "";
              todate = "";
            }
          }

          charListVal?.push([
            i + 1,
            Date.parse(fromdate),
            Date.parse(todate),
            "",
            cherID,
            chargerTableData[i]?.setpoints,
            Date.parse(recFromdate),
          ]);
        }
      }
    }

    setChargerGraph(charListVal);
    setChargerList(chargerGraphdata);
    setChargertableRow(chargerTableData);
    // console.log('text',chargerTableData)
  };

  const getStringMinHours = (val) => {
    if (val < 10) {
      if (val === 0) {
        return "00";
      } else {
        return "0" + val;
      }
    } else {
      return val;
    }
  };

  const chargerdayMap = (weekDays) => {
    // for (let i = 0; i < weekDays?.length; i++) {
    if (weekDays?.power !== 0) {
      if (weekDays?.dayOfWeek === "MONDAY") {
        return 0;
      }
      if (weekDays?.dayOfWeek === "TUESDAY") {
        return 1;
      }
      if (weekDays?.dayOfWeek === "WEDNESDAY") {
        return 2;
      }
      if (weekDays?.dayOfWeek === "THURSDAY") {
        return 3;
      }
      if (weekDays?.dayOfWeek === "FRIDAY") {
        return 4;
      }
      if (weekDays?.dayOfWeek === "SATURDAY") {
        return 5;
      }
      if (weekDays?.dayOfWeek === "SUNDAY") {
        return 6;
      }
      // }
    }
  };
  const delSchedule = async (chargerId, strRecurring) => {
    if (strRecurring === "oneTime") {
      if (chargertripstate === "Trip Schedule") {
        await deleteRequest(`one-time-soc-requirements/` + chargerId).then(
          (resData) => {
            chargerListdata();
          }
        );
      } else {
        await deleteRequest(
          `one-time-power-setpoints-schedules/` + chargerId
        ).then((resData) => {
          chargerListdata();
        });
      }
    } else {
      if (chargertripstate === "Trip Schedule") {
        await deleteRequest(`recurring-soc-requirements/` + chargerId).then(
          (resData) => {
            chargerListdata();
          }
        );
      } else {
        await deleteRequest(
          `weekly-power-setpoints-schedules/` + chargerId
        ).then((resData) => {
          chargerListdata();
        });
      }
    }
  };
  let width = document?.getElementById("giraphWidth")?.offsetWidth;

  let leftW = document?.getElementById("leftWidth")?.offsetWidth;
  // console.log('width',leftW)
  return (
    <>
      <div
        className={cn(Urls !== "/TripAndChargeSchedule" ? styles.popup : "")}
      >
        <div
          className={cn(
            Urls !== "/TripAndChargeSchedule" ? styles.popup_inner : ""
          )}
        >
          {Urls !== "/TripAndChargeSchedule" ? (
            <img
              className={cn(styles.popup_Close)}
              src={require("assets/close.png").default}
              alt="Rectangle 36"
              onClick={() => props.popupState(null)}
            />
          ) : (
            ""
          )}
          <div className={cn(styles.filter, styles.filter_layout)}>
            <div className={cn(styles.filter_item)}>
              <div
                className={cn(
                  styles.options_block,
                  styles.options_block_layout
                )}
              >
                <div
                  className={cn(styles.option_flex, styles.option_flex_layout)}
                >
                  {chargertripstate === "Charging Schedule" ? (
                    <>
                      {/* <label className={cn(styles.customCheckbox)}>
                      <input type="radio" checked={chargertripstate === 'Charging Schedule' ? true : false} id="charging_schedule" name="Charging_trip_Schedule" onChange={handleChange} value="Charging Schedule" />
                      <span className={cn(styles.checkmarkDropdown)}></span>
                    </label> */}
                      {/* <input type="radio" checked={chargertripstate==='Charging Schedule'?true:false} id="charging_schedule" name="Charging_trip_Schedule" onChange={handleChange} value="Charging Schedule" /> */}
                      {/* <div className={cn(styles.option_flex_item)}>
 <img
 src={
 require('assets/arrow.svg')
 .default
 }
 alt="Rectangle 1069"
 className={cn(styles.box10, styles.box10_layout)}
 />
 </div>*/}
                      {/* <div className={cn(styles.option_flex_spacer)} /> */}
                      <h3
                        className={cn(
                          styles.subb_title_text,
                          styles.subTitle_midiumBold,
                          styles.subb_title_text_layout
                        )}
                      >
                        {"Charging Schedule"}
                      </h3>
                    </>
                  ) : (
                    ""
                  )}
                  <div className={cn(styles.option_flex_spacer1)} />
                  {/* <div className={cn(styles.option_flex_item1)}>
 <img
 src={
 require('assets/arrow.svg')
 .default
 }
 alt="Rectangle 1070"
 className={cn(styles.box10, styles.box10_layout1)}
 />
 </div> */}
                  {chargertripstate === "Trip Schedule" ? (
                    <>
                      {/* <label className={cn(styles.customCheckbox)}>
                      <input type="radio" id="trip_schedule" checked={chargertripstate === 'Trip Schedule' ? true : false} name="Charging_trip_Schedule" onChange={handleChange} value="Trip Schedule" />
                      <span className={cn(styles.checkmarkDropdown)}></span>
                    </label> */}
                      {/* <div className={cn(styles.option_flex_spacer2)} /> */}
                      <h3
                        className={cn(
                          styles.subb_title_text,
                          styles.subTitle_midiumBold,
                          styles.subb_title_text_layout
                        )}
                      >
                        {"Trip Schedule"}
                      </h3>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            <h3
              className={cn(
                styles.subb_title_text,
                styles.titlebold,
                styles.subb_title_text_layout1
              )}
            >
              {"Date:"}
            </h3>
            <div className={cn(styles.filter_spacer)} />
            <div className={cn(styles.filter_item1)}>
              <div
                className={cn(
                  styles.datepicker_block,
                  styles.datepicker_block_layout
                )}
              >
                {/* <div className={cn(styles.flex5, styles.flex5_layout)}>
 <div
 className={cn(
 styles.normal_text,
 styles.normal_text_layout
 )}>
 {'{{set.opt 1}}'}
 </div>
 
 <div className={cn(styles.flex5_spacer)} />
 <div className={cn(styles.flex5_item)}>
 <img
 src={
 require('assets/arrow.svg')
 .default
 }
 alt="Rectangle 1071"
 className={cn(styles.box10, styles.box10_layout2)}
 />
 </div>
 </div> */}
                {/* 
 <DatePicker onChange={onChange} value={dateValue} format={"d-MM-yyyy"} />
 <div style={{"position":"absolute","right":'5px','top':'7px','zIndex':'0'}}>
 <img src={
 require('assets/calendar.svg')
 .default
 }/>
 </div> */}
                <Calendar
                  dateCallback={selectDate}
                  todaydateSelected={todaydate}
                  previousWeek={PreviousWeek}
                  nextWeek={nextWeek}
                  changedate={selectedDay}
                />
              </div>
            </div>
            <div className={cn(styles.filter_spacer1)} />
            <div className={cn(styles.filter_item2)}>
              <div
                onClick={() => today()}
                className={cn(styles.cover_block9, styles.cover_block9_layout)}
              >
                <div
                  className={cn(
                    styles.normal_text1,
                    styles.normal_text1_layout
                  )}
                >
                  {"Today"}
                </div>
              </div>
            </div>
            {/* <div className={cn(styles.filter_spacer2)} /> */}
            {/* <h3 className={cn(styles.subb_title_text, styles.subTitle_midiumBold,styles.subb_title_text_layout2)}>
 {'Auto Copy Schedule'}
 </h3> */}
            {/* <div className={cn(styles.filter_spacer3)} />
 <div className={cn(styles.filter_item3)}>
 <div
 className={cn(styles.on_block, styles.on_block_layout)}
 onClick={() => alert('It is clickable')}>
 <div className={cn(styles.on_box, styles.on_box_layout)} />
 <div
 className={cn(
 styles.normal_text,
 styles.normal_text_layout1
 )}>
 {'On'}
 </div>
 </div>
 </div>
 <div className={cn(styles.filter_item4)}>
 <div
 className={cn(styles.off_block, styles.off_block_layout)}
 onClick={() => alert('It is clickable')}>
 <div className={cn(styles.off_box, styles.off_box_layout)} />
 <div
 className={cn(
 styles.normal_text2,
 styles.normal_text2_layout
 )}>
 {'Off'}
 </div>
 </div>
 </div> */}
            {/* <div className={cn(styles.filter_spacer5)} /> */}
            {/* <div className={cn(styles.filter_item2)}>
 <div
 className={cn(styles.cover_block9, styles.cover_block9_layout)}>

 </div>
 </div> */}
            <div className={cn(styles.filter_spacer5)} />
            <div className={cn(styles.filter_item5, styles.filetButtom)}>
              {Urls !== "/TripAndChargeSchedule" ? (
                <div
                  onClick={(e) => addHandleChange(true)}
                  className={
                    hideaddbutton === false
                      ? cn(styles.cover_block9, styles.cover_block9_layout)
                      : cn(styles.displayNone)
                  }
                >
                  <div
                    className={cn(
                      styles.normal_text1,
                      styles.normal_text1_layout
                    )}
                  >
                    {"Add Schedule"}
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          {/* <div className={cn(styles.errorMessageShow)}>Conflict with already existing schedule.</div> */}
          <div
            className={
              showError === true
                ? cn(styles.errorMessageShow)
                : cn(styles.errorMessageHide)
            }
          >
            Conflict with already existing schedule.
          </div>
          <div className={cn(styles.minMaxHeight)}>
            <div
              id="giraphWidth"
              style={{ width: "100%", height: "100%", overflowY: "visible" }}
            >
              <div
                className={cn(styles.site_group, styles.site_group_layout)}
                style={{
                  "--height":
                    +Arraycount === 1
                      ? 220 + "px"
                      : Arraycount === 2
                      ? 280 + "px"
                      : Arraycount === 4
                      ? 120 * Arraycount + "px"
                      : 120 * Arraycount + "px",
                  // '--height': +Arraycount < 5 ? 600 + 'px' : 120 * Arraycount + "px",
                  maxHeight: "600px",
                  width: "100%",
                }}
              >
                <div className={cn(styles.table)}>
                  <div
                    className={cn(styles.site_box, styles.table__cell__site)}
                    // className={cn(styles.site_box, styles.site_box_layout)}
                  >
                    <div className={cn(styles.overlapText)} id="leftWidth">
                      <h3
                        className={cn(
                          styles.subb_title_text8,
                          styles.subb_title_text8_layout
                        )}
                      >
                        {chargertripstate === "Trip Schedule"
                          ? "Vehicles List"
                          : "Chargers List"}
                      </h3>
                    </div>

                    <div
                      className={cn(
                        styles.site_list_block,
                        styles.site_list_block_layout
                      )}
                    >
                      <div
                        className={cn(
                          styles.site_text_body,
                          styles.site_text_body_layout
                        )}
                      >
                        {""}
                      </div>
                    </div>
                  </div>

                  <div
                    className={
                      selectedDay === 0
                        ? cn(
                            styles.expand_day_cover,
                            styles.table__cell__activemtw
                          )
                        : cn(styles.collapse_day_cover, styles.table__cell)
                    }

                    // className={cn(styles.collapse_day_cover, styles.table__cell ) }
                  >
                    <div
                      className={cn(
                        styles.collapse_day_head_block,
                        styles.collapse_day_head_block_layout_dymanic
                      )}
                      style={{
                        "--margin":
                          Arraycount < 5
                            ? 550 + "px"
                            : Arraycount >= 5 && Arraycount <= 8
                            ? 110 * Arraycount + "px"
                            : Arraycount >= 9
                            ? 118 * Arraycount + "px"
                            : 94 * Arraycount + "px",
                        // '--margin': Arraycount === 1 ? 99 + 'px' : Arraycount === 3 ? (101 * Arraycount)-1 + 'px' : Arraycount >= 4 && Arraycount <= 8 ? (110 * Arraycount)-1 + 'px' : Arraycount >= 9 ? (118 * Arraycount)-1 + 'px' : (94 * Arraycount)-1 + 'px'
                      }}
                    >
                      <div
                        className={cn(
                          styles.collapse_day_head2,
                          styles.collapse_day_head2_layout,
                          selectedDay === 0
                            ? styles.expand_day_head2_layout
                            : ""
                        )}
                        onClick={() => setSelectedDay(0)}
                      >
                        <h3
                          className={cn(
                            styles.subb_title_text7,
                            styles.subb_title_text7_layout
                          )}
                        >
                          {selectedDay === 0 ? (
                            <div>
                              Monday
                              <br />
                              {date}{" "}
                            </div>
                          ) : (
                            "M"
                          )}
                          {/* {'M'} */}
                        </h3>
                      </div>
                    </div>
                  </div>

                  <div
                    className={
                      selectedDay === 1
                        ? cn(
                            styles.expand_day_cover,
                            styles.table__cell__activemtw
                          )
                        : cn(styles.collapse_day_cover, styles.table__cell)
                    }

                    // className={cn(styles.collapse_day_cover, styles.table__cell)}
                  >
                    <div
                      className={cn(
                        styles.collapse_day_head_block,
                        styles.collapse_day_head_block_layout_dymanic
                      )}
                      style={{
                        "--margin":
                          Arraycount < 5
                            ? 550 + "px"
                            : Arraycount >= 5 && Arraycount <= 8
                            ? 110 * Arraycount + "px"
                            : Arraycount >= 9
                            ? 118 * Arraycount + "px"
                            : 94 * Arraycount + "px",
                        // '--margin': Arraycount === 1 ? 99 + 'px' : Arraycount === 3 ? (101 * Arraycount)-1 + 'px' : Arraycount >= 4 && Arraycount <= 8 ? (110 * Arraycount)-1 + 'px' : Arraycount >= 9 ? (118 * Arraycount)-1 + 'px' : (94 * Arraycount)-1 + 'px'
                      }}
                    >
                      <div
                        className={cn(
                          styles.collapse_day_head2,
                          styles.collapse_day_head2_layout,
                          selectedDay === 1
                            ? styles.expand_day_head2_layout
                            : ""
                        )}
                        onClick={() => setSelectedDay(1)}
                      >
                        <h3
                          className={cn(
                            styles.subb_title_text7,
                            styles.subb_title_text7_layout
                          )}
                        >
                          {selectedDay === 1 ? (
                            <div>
                              Tuesday
                              <br />
                              {date}{" "}
                            </div>
                          ) : (
                            "T"
                          )}
                          {/* {'TU'} */}
                        </h3>
                      </div>
                    </div>
                  </div>

                  <div
                    className={
                      selectedDay === 2
                        ? cn(
                            styles.expand_day_cover,
                            styles.table__cell__activemtw
                          )
                        : cn(styles.collapse_day_cover, styles.table__cell)
                    }

                    // className={cn(styles.collapse_day_cover, styles.table__cell)}
                  >
                    <div
                      className={cn(
                        styles.collapse_day_head_block,
                        styles.collapse_day_head_block_layout_dymanic
                      )}
                      style={{
                        "--margin":
                          Arraycount < 5
                            ? 550 + "px"
                            : Arraycount >= 5 && Arraycount <= 8
                            ? 110 * Arraycount + "px"
                            : Arraycount >= 9
                            ? 118 * Arraycount + "px"
                            : 94 * Arraycount + "px",
                        // '--margin': Arraycount === 1 ? 99 + 'px' : Arraycount === 3 ? (101 * Arraycount)-1 + 'px' : Arraycount >= 4 && Arraycount <= 8 ? (110 * Arraycount)-1 + 'px' : Arraycount >= 9 ? (118 * Arraycount)-1 + 'px' : (94 * Arraycount)-1 + 'px'
                      }}
                    >
                      <div
                        className={cn(
                          styles.collapse_day_head2,
                          styles.collapse_day_head2_layout,
                          selectedDay === 2
                            ? styles.expand_day_head2_layout
                            : ""
                        )}
                        onClick={() => setSelectedDay(2)}
                      >
                        <h3
                          className={cn(
                            styles.subb_title_text7,
                            styles.subb_title_text7_layout
                          )}
                        >
                          {selectedDay === 2 ? (
                            <div>
                              Wednesday
                              <br />
                              {date}{" "}
                            </div>
                          ) : (
                            "W"
                          )}
                          {/* {'W'} */}
                        </h3>
                      </div>
                    </div>
                  </div>

                  <div
                    className={
                      selectedDay === 3
                        ? cn(
                            styles.expand_day_cover,
                            styles.table__cell__activemtw
                          )
                        : cn(styles.collapse_day_cover, styles.table__cell)
                    }

                    // className={cn(styles.collapse_day_cover, styles.table__cell)}
                  >
                    <div
                      className={cn(
                        styles.collapse_day_head_block,
                        styles.collapse_day_head_block_layout_dymanic
                      )}
                      style={{
                        "--margin":
                          Arraycount < 5
                            ? 550 + "px"
                            : Arraycount >= 5 && Arraycount <= 8
                            ? 110 * Arraycount + "px"
                            : Arraycount >= 9
                            ? 118 * Arraycount + "px"
                            : 94 * Arraycount + "px",
                        // '--margin': Arraycount === 1 ? 99 + 'px' : Arraycount === 3 ? (101 * Arraycount)-1 + 'px' : Arraycount >= 4 && Arraycount <= 8 ? (110 * Arraycount)-1 + 'px' : Arraycount >= 9 ? (118 * Arraycount)-1 + 'px' : (94 * Arraycount)-1 + 'px'
                      }}
                    >
                      <div
                        className={cn(
                          styles.collapse_day_head2,
                          styles.collapse_day_head2_layout,
                          selectedDay === 3
                            ? styles.expand_day_head2_layout
                            : ""
                        )}
                        onClick={() => setSelectedDay(3)}
                      >
                        <h3
                          className={cn(
                            styles.subb_title_text7,
                            styles.subb_title_text7_layout
                          )}
                        >
                          {selectedDay === 3 ? (
                            <div>
                              Thursday
                              <br />
                              {date}{" "}
                            </div>
                          ) : (
                            "Th"
                          )}
                          {/* {'Th'} */}
                        </h3>
                      </div>
                    </div>
                  </div>

                  <div
                    // className={cn(styles.collapse_day_cover, styles.table__cell)}
                    className={
                      selectedDay === 4
                        ? cn(
                            styles.expand_day_cover,
                            styles.table__cell__active1
                          )
                        : cn(styles.collapse_day_cover, styles.table__cell)
                    }
                  >
                    <div
                      className={cn(
                        styles.collapse_day_head_block,
                        styles.collapse_day_head_block_layout_dymanic
                      )}
                      style={{
                        "--margin":
                          Arraycount < 5
                            ? 550 + "px"
                            : Arraycount >= 5 && Arraycount <= 8
                            ? 110 * Arraycount + "px"
                            : Arraycount >= 9
                            ? 118 * Arraycount + "px"
                            : 94 * Arraycount + "px",
                        // '--margin': Arraycount === 1 ? 99 + 'px' : Arraycount === 3 ? (101 * Arraycount)-1 + 'px' : Arraycount >= 4 && Arraycount <= 8 ? (110 * Arraycount)-1 + 'px' : Arraycount >= 9 ? (118 * Arraycount)-1 + 'px' : (94 * Arraycount)-1 + 'px'
                      }}
                    >
                      <div
                        className={cn(
                          styles.collapse_day_head2,
                          styles.collapse_day_head2_layout,
                          selectedDay === 4
                            ? styles.expand_day_head2_layout
                            : ""
                        )}
                        onClick={() => setSelectedDay(4)}
                      >
                        <h3
                          className={cn(
                            styles.subb_title_text7,
                            styles.subb_title_text7_layout
                          )}
                        >
                          {selectedDay === 4 ? (
                            <div>
                              Friday
                              <br />
                              {date}{" "}
                            </div>
                          ) : (
                            "F"
                          )}
                          {/* {'F'} */}
                        </h3>
                      </div>
                    </div>
                  </div>

                  <div
                    className={
                      selectedDay === 5
                        ? cn(
                            styles.expand_day_cover,
                            styles.table__cell__active1
                          )
                        : cn(styles.collapse_day_cover, styles.table__cell)
                    }

                    // className={cn(styles.expand_day_cover, styles.table__cell__active1)}

                    // className={cn(styles.expand_day_cover, styles.expand_day_cover_layout)}
                  >
                    <div
                      className={cn(
                        styles.collapse_day_head_block,
                        styles.collapse_day_head_block_layout_dymanic
                      )}
                      style={{
                        "--margin":
                          Arraycount < 5
                            ? 550 + "px"
                            : Arraycount >= 5 && Arraycount <= 8
                            ? 110 * Arraycount + "px"
                            : Arraycount >= 9
                            ? 118 * Arraycount + "px"
                            : 94 * Arraycount + "px",
                        // '--margin': Arraycount === 1 ? 99 + 'px' : Arraycount === 3 ? (101 * Arraycount)-1+ 'px' : Arraycount >= 4 && Arraycount <= 8 ? (110 * Arraycount)-1 + 'px' : Arraycount >= 9 ? (118 * Arraycount)-1 + 'px' :( 94 * Arraycount)-1 + 'px'
                      }}
                    >
                      <div
                        className={cn(
                          styles.collapse_day_head2,
                          styles.collapse_day_head2_layout,
                          selectedDay === 5
                            ? styles.expand_day_head2_layout
                            : ""
                        )}
                        // onClick={setSelectedDay(5)}
                        onClick={() => setSelectedDay(5)}
                      >
                        <h3
                          className={cn(
                            styles.subb_title_text7,
                            styles.subb_title_text7_layout
                          )}
                        >
                          {selectedDay === 5 ? (
                            <div>
                              Saturday
                              <br />
                              {date}{" "}
                            </div>
                          ) : (
                            "S"
                          )}
                          {/* {'Sa'} */}
                        </h3>
                      </div>
                    </div>
                  </div>

                  <div
                    // className={cn(styles.collapse_day_cover, styles.table__cell)}
                    className={
                      selectedDay === 6
                        ? cn(
                            styles.expand_day_cover,
                            styles.collapse_day6_Active,
                            styles.table__cell__active1
                          )
                        : cn(
                            styles.collapse_day_cover,
                            styles.collapse_day6_cover,
                            styles.table__cell
                          )
                    }

                    // className={cn(styles.datepicker_block1, styles.datepicker_block1_layout)}
                  >
                    <div
                      className={cn(
                        styles.collapse_day_head_block,
                        styles.collapse_day_head_block_layout_dymanic
                      )}
                      style={{
                        "--margin":
                          Arraycount < 5
                            ? 550 + "px"
                            : Arraycount >= 5 && Arraycount <= 8
                            ? 110 * Arraycount + "px"
                            : Arraycount >= 9
                            ? 118 * Arraycount + "px"
                            : 94 * Arraycount + "px",
                        // '--margin': Arraycount === 1 ? 99 + 'px' : Arraycount === 3 ? (101 * Arraycount)-1 + 'px' : Arraycount >= 4 && Arraycount <= 8 ? (110 * Arraycount)-1 + 'px' : Arraycount >= 9 ? (118 * Arraycount)-1 + 'px' : (94 * Arraycount)-1 + 'px'
                      }}
                    >
                      <div
                        className={cn(
                          styles.collapse_day_head2,
                          styles.collapse_day_head2_layout,
                          selectedDay === 6
                            ? styles.expand_day_head2_layout
                            : ""
                        )}
                        // onClick={() => alert('It is clickable')}
                        onClick={() => setSelectedDay(6)}
                        // onClick={setSelectedDay(6)}
                      >
                        <div
                          className={cn(
                            styles.subb_title_text7,
                            styles.subb_title_text7_layout
                          )}
                        >
                          {selectedDay === 6 ? (
                            <div>
                              Sunday
                              <br />
                              {date}{" "}
                            </div>
                          ) : (
                            "Su"
                          )}

                          {/* {"Sunday \n"}
 <br/>
 {date} */}

                          {/* {'Su'} */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className={cn(
                    styles.datepicker_block1,
                    chargertripstate === "Trip Schedule"
                      ? selectedDay === 6
                        ? styles.datepicker_block1_layout_su
                        : selectedDay === 5
                        ? styles.datepicker_block1_layout_sa
                        : selectedDay === 4
                        ? styles.datepicker_block1_layout_f
                        : selectedDay === 3
                        ? styles.datepicker_block1_layout_th
                        : selectedDay === 2
                        ? styles.datepicker_block1_layout_w
                        : selectedDay === 1
                        ? styles.datepicker_block1_layout_tu
                        : styles.datepicker_block1_layout_m
                      : selectedDay === 6
                      ? styles.datepicker_block1_layout_su1
                      : selectedDay === 5
                      ? styles.datepicker_block1_layout_sa1
                      : selectedDay === 4
                      ? styles.datepicker_block1_layout_f1
                      : selectedDay === 3
                      ? styles.datepicker_block1_layout_th1
                      : selectedDay === 2
                      ? styles.datepicker_block1_layout_w1
                      : selectedDay === 1
                      ? styles.datepicker_block1_layout_tu1
                      : styles.datepicker_block1_layout_m1
                  )}
                >
                  {chargertableRow?.length > 0 ? (
                    <Gantt
                      letList={leftW}
                      graphWidth1={width}
                      rowDataTable={chargertableRow}
                      rowChargerGraph={chargerGraph}
                      rowChargerList={chargerList}
                      chargerTripShedule={chargertripstate}
                      gap={24 - (6 - selectedDay) * 3.45}
                      day={selectedDay}
                      popupCallBack={TripPData}
                    ></Gantt>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className={cn(styles.filter_spacer2)} />
          <div className={cn(styles.flex6, styles.flex6_layout)}>
            <h3
              className={cn(
                styles.subb_title_text10,
                styles.subb_title_text10_layout
              )}
              onClick={(e) => previousWeak()}
            >
              {"< Previous Week"}
            </h3>
            <div className={cn(styles.flex6_spacer)} />
            <div className={cn(styles.flex6_item)}>
              {/* <div
 className={cn(styles.cover_block, styles.cover_block_layout)}
 onClick={() => alert('It is clickable')}>
 <h3 className={cn(styles.subb_title_text21, styles.subb_title_text21_layout)}>
 {'COPY SCHEDULE TO NEXT WEEK'}
 </h3>
 </div> */}
            </div>
            <div className={cn(styles.flex6_spacer1)} />
            <h3
              onClick={(e) => nextWeak()}
              className={cn(
                styles.subb_title_text11,
                styles.subb_title_text11_layout
              )}
            >
              {"Next Week >"}
            </h3>
          </div>
        </div>
      </div>
      {secondPopup === true ? (
        <TripPopup
          deleteCall={deleteCallBack}
          scheduleddata={callBackscheduleData}
          chargerid={chargerId}
          closePopu={closePopup}
          chargetrip={chargertripstate}
          data={trippopData}
          addClick={addtripcharge}
        />
      ) : (
        ""
      )}
      {/* { addtripcharge===true?
 <AddTripAndCharge closeAddTrip={closeAddPopup} />
 :''
 } */}
    </>
  );
}

TripAndCharge.inStorybook = false;
